import {
  CREATEACTIVITY,
  GETACTIVITY,
  DELETEACTIVITY,
  UPDATEACTIVITY,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETACTIVITY:
      return {
        ...state,
        activityList: action.payload.data,
      };
    case UPDATEACTIVITY:
      return {
        ...state,
        activityUpdateStatus: action.payload.success,
      };

    case DELETEACTIVITY:
      return {
        ...state,
        activityDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
